/**
 * Finds a graphical center of the image (canvas)
 */
export default class ImageCenterResolver {
	/**
	 * Finds center of the image in the specified canvas element
	 *
	 * @param {HTMLCanvasElement|HTMLImageElement} img
	 * @returns {{x: number, y: number}}
	 */
	getCenter(img) {
		let c;

		if (img.tagName === 'IMG') {
			c = document.createElement('canvas');
			c.width = img.naturalWidth;
			c.height = img.naturalHeight;
			c.getContext('2d').drawImage(img, 0, 0);
		} else {
			c = img;
		}

		const ctx = c.getContext('2d');
		const width = c.width;
		const height = c.height;
		const pixels = ctx.getImageData(0, 0, width, height).data;
		const len = pixels.length;

		let x, y, x0, y0, x1, y1;

		// find most left pixel
		for (let i = 3; i < len; i += 4) {
			if (pixels[i] > 0) {
				let pixelIndex = (i - 3) / 4;
				y = Math.floor(pixelIndex / width);
				x = pixelIndex - (y * width);

				if (x0 === undefined || x < x0) {
					x0 = x;
				}

				if (x1 === undefined || x > x1) {
					x1 = x;
				}

				if (y0 === undefined || y < y0) {
					y0 = y;
				}

				if (y1 === undefined || y > y1) {
					y1 = y;
				}
			}
		}

		if (x0 === undefined) {
			// return center of the canvas
			return {
				x: width >> 1,
				y: height >> 1,
			};
		}

		return {
			x: x0 + ((x1 - x0) >> 1),
			y: y0 + ((y1 - y0) >> 1)
		};
	}
}
